// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
//公用样式
import '@/assets/css/reset.css'
import '@/assets/css/main.css'
import '@/assets/css/media.css'
import '@/assets/iconfont/iconfont.css'
import '@/common/rem.js'

import "swiper/dist/css/swiper.min.css";

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// 国际化
const i18n = new VueI18n({
    locale: 'zh', // set locale
    messages: {
        zh: require('./language/zh.js'),//引入语言文件
        en: require('./language/en.js'),//英文
        kr: require('./language/kr.js'),//韩语
        jp: require('./language/jp.js'),//日语
    }
})

new Vue({
    el: '#app',
    router,
    i18n,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js